import React from 'react';

function DownloadButton({ link, filename, buttonName, classes, disable }) {
  const downloadPdf = () => {
    const a = document.createElement('a');
    a.href = link;
    a.download = filename || 'file.pdf'; 
    a.click();
  };

  return (
    <button disabled={disable} className={classes} onClick={downloadPdf}>{buttonName}</button>
  );
}

export default DownloadButton;
